/**
 * Local service landing pages — service + city landers per §4 of the SEO brief.
 * Each entry drives one route (e.g. `/services/botox-alhambra`) with an
 * intent-matched H1, meta, FAQs, and internal links to related services.
 */
export const localLanders = {
  'botox-alhambra': {
    slug: 'botox-alhambra',
    primaryKeyword: 'Botox Alhambra',
    title: 'Botox in Alhambra, CA | Physician-Led | Akira Signature Care',
    metaDescription:
      'Botox® in Alhambra by a physician-led team with Angela Trias, M.D. Natural results, consult-first. Serving SGV. Call (626) 737-3183.',
    h1: 'Botox in Alhambra, CA',
    hero: {
      eyebrow: 'PHYSICIAN-LED · ALHAMBRA',
      subhead:
        'Botox®, Dysport®, Xeomin® & Letybo® — chosen and dosed by our physician-led team.',
      image:
        'https://images.pexels.com/photos/3985338/pexels-photo-3985338.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who Botox is for',
      body: 'Ideal for women (and men) 30 and up who want a natural, refreshed look — not a frozen one. Whether you\u2019re starting preventatively, softening dynamic lines, or refining a long-standing routine, treatment is tailored to your anatomy, muscle strength, and how much movement you want to keep.',
    },
    whyPhysicianLed:
      'Every visit is planned by our physician-led team under the medical direction of Angela Trias, M.D. We map your facial dynamics before dosing, choose the neuromodulator (Botox®, Dysport®, Xeomin® or Letybo®) that best fits your muscle activity and goals, and adjust units precisely — no cookie-cutter menus.',
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A conversation about your goals, medical history, and prior injectables. We photograph and map your facial expressions to plan units and placement.',
      },
      {
        step: 'Treatment',
        body:
          'Ultra-fine needles, ~10–15 minutes. Most patients describe it as a series of quick pinches; topical numbing available on request.',
      },
      {
        step: 'Aftercare',
        body:
          'Resume normal activity right away. Skip intense workouts, heat, and lying flat for 4 hours. Full result at ~10–14 days; we check in and refine at your follow-up.',
      },
    ],
    related: [
      { slug: '/services/dermal-fillers-alhambra', name: 'Dermal Fillers in Alhambra' },
      { slug: '/services/rf-microneedling', name: 'RF Microneedling' },
      { slug: '/services/prp-facial', name: 'PRP & PRF Regenerative Therapy' },
    ],
    faqs: [
      {
        q: 'How much does Botox cost in Alhambra at Akira?',
        a:
          'Pricing is per unit and depends on the areas treated and the neuromodulator selected. Your consultation includes a written plan with exact unit counts and cost before we treat.',
      },
      {
        q: 'How long does it last?',
        a:
          'Most patients maintain results for 3–4 months. Consistent treatment over time can lengthen the interval as trained muscles relax.',
      },
      {
        q: 'Will I look frozen?',
        a:
          'No. Our approach is deliberately conservative for first visits — you can add more, you can\u2019t take it away. We favour natural movement.',
      },
      {
        q: 'When should I start Botox?',
        a:
          'Some patients start preventatively in their late 20s; others wait until dynamic lines appear. There\u2019s no single right age — the decision is anatomical, not chronological.',
      },
      {
        q: 'Is Botox safe?',
        a:
          'Neuromodulators have been FDA-approved for aesthetic use since 2002 and have decades of safety data. Complications are rare when treatment is performed by a licensed, physician-supervised injector using genuine product.',
      },
    ],
    servingNearby: [
      'Pasadena', 'Arcadia', 'San Marino', 'Monterey Park', 'South Pasadena', 'Eagle Rock', 'Silver Lake',
    ],
  },

  'dermal-fillers-alhambra': {    slug: 'dermal-fillers-alhambra',
    primaryKeyword: 'Dermal Fillers Alhambra',
    title: 'Dermal Fillers in Alhambra | Juv\u00e9derm & Restylane | Akira',
    metaDescription:
      'Dermal fillers in Alhambra — Juv\u00e9derm®, Restylane® & biostimulators with physician oversight. Book (626) 737-3183.',
    h1: 'Dermal Fillers in Alhambra, CA',
    hero: {
      eyebrow: 'PHYSICIAN-LED · ALHAMBRA',
      subhead:
        'Juvéderm®, Restylane® and biostimulators like Sculptra® — planned by anatomy, not by trend.',
      image:
        'https://images.pexels.com/photos/3985329/pexels-photo-3985329.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who dermal fillers are for',
      body: 'Patients who want to restore lost volume, refine facial proportions, hydrate skin, or soften static lines that Botox alone won\u2019t address. Treatment is planned to your face — not to trends — so results look like you, only rested.',
    },
    whyPhysicianLed:
      'Filler is anatomy, not a menu. Every plan is designed by our physician-led team under the medical direction of Angela Trias, M.D., using product families (Juv\u00e9derm®, Restylane®, and biostimulators such as Sculptra®) matched to your tissue type, thickness, and desired longevity.',
    whatToExpected: [],
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A structured facial-mapping session where we identify volume loss, asymmetry, and support-point priorities. You receive a written plan before treatment.',
      },
      {
        step: 'Treatment',
        body:
          'Precise, small-syringe placement with cannula or needle depending on the area. Topical numbing plus lidocaine within the product keep the visit comfortable.',
      },
      {
        step: 'Aftercare',
        body:
          'Mild swelling and small bruises are normal for 24–72 hours. Avoid strenuous exercise, alcohol, and dental work for the first 24 hours. We photograph and refine at follow-up.',
      },
    ],
    related: [
      { slug: '/services/botox-alhambra', name: 'Botox in Alhambra' },
      { slug: '/services/rf-microneedling', name: 'RF Microneedling' },
      { slug: '/services/prp-facial', name: 'PRP & PRF Regenerative Therapy' },
    ],
    faqs: [
      {
        q: 'How much do fillers cost at Akira?',
        a:
          'Pricing is per syringe and per product family. Your consultation includes a written treatment plan with clear per-syringe costs before you commit to anything.',
      },
      {
        q: 'How long do fillers last?',
        a:
          'Hyaluronic-acid fillers typically last 9–18 months depending on the product and treatment area. Biostimulators like Sculptra® stimulate your own collagen and can last 18–24+ months.',
      },
      {
        q: 'Will fillers look obvious?',
        a:
          'Not when planned properly. Overfilled looks come from chasing trends and stacking product; we plan by anatomy and use conservative volumes with follow-up rather than one heavy session.',
      },
      {
        q: 'Are fillers reversible?',
        a:
          'Hyaluronic-acid fillers can be dissolved with hyaluronidase if you don\u2019t like the result. Biostimulators are not reversible, which is one reason we start conservatively.',
      },
      {
        q: 'What\u2019s the difference between Juv\u00e9derm and Restylane?',
        a:
          'Both are hyaluronic-acid fillers, but they behave differently: Juv\u00e9derm formulas tend to be smoother and integrate softly; Restylane formulas tend to hold shape more firmly. We choose the family based on the area and outcome you want.',
      },
    ],
    servingNearby: [
      'Pasadena', 'Arcadia', 'San Marino', 'Monterey Park', 'South Pasadena', 'Eagle Rock', 'Silver Lake',
    ],
  },

  'botox-san-marino': {
    slug: 'botox-san-marino',
    primaryKeyword: 'Botox San Marino',
    title: 'Botox near San Marino | Akira Signature Care Alhambra',
    metaDescription:
      'Botox® for San Marino patients at our Alhambra clinic — physician-led injectables with Angela Trias, M.D. (626) 737-3183.',
    h1: 'Botox for San Marino Patients',
    hero: {
      eyebrow: 'PHYSICIAN-LED · SERVING SAN MARINO',
      subhead:
        'Botox®, Dysport®, Xeomin® and Letybo® at our Alhambra clinic — a short drive from San Marino.',
      image:
        'https://images.pexels.com/photos/3985338/pexels-photo-3985338.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who this is for',
      body: 'San Marino patients who want a natural, refreshed look — not a frozen one — and prefer a physician-led setting close to home. Whether you\u2019re starting preventatively, softening dynamic lines, or refining a long-standing routine, treatment is planned to your anatomy and how much movement you want to keep.',
    },
    whyPhysicianLed:
      'Our Alhambra clinic is a short drive from San Marino. Every visit is planned by our physician-led team under the medical direction of Angela Trias, M.D. — we map your facial dynamics, choose the neuromodulator (Botox®, Dysport®, Xeomin® or Letybo®) that best fits your muscles and goals, and dose conservatively. You can always add; you can\u2019t take away.',
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A structured planning session — goals, medical history, prior injectables, and a facial-mapping review. You receive a written plan with unit counts and cost before we treat.',
      },
      {
        step: 'Treatment',
        body:
          '~10–15 minutes with ultra-fine needles. Most patients describe it as a series of quick pinches; topical numbing available on request.',
      },
      {
        step: 'Aftercare',
        body:
          'Resume normal activity right away. Skip heavy workouts, heat, and lying flat for 4 hours. Full result at ~10–14 days; we photograph and refine at follow-up.',
      },
    ],
    related: [
      { slug: '/services/botox-alhambra', name: 'Botox in Alhambra' },
      { slug: '/services/dermal-fillers-alhambra', name: 'Dermal Fillers in Alhambra' },
      { slug: '/locations/san-marino', name: 'Our San Marino Location Page' },
    ],
    faqs: [
      {
        q: 'How far is Akira Signature Care from San Marino?',
        a:
          'Our Alhambra clinic (506 N Garfield Ave, Ste 210) is a short drive from San Marino — most patients arrive in 10–15 minutes with easy street and lot parking.',
      },
      {
        q: 'How much does Botox cost at Akira?',
        a:
          'Pricing is per unit and depends on the areas treated and the neuromodulator selected. Your consultation includes a written plan with exact unit counts and cost before we treat.',
      },
      {
        q: 'How long does Botox last?',
        a:
          'Most patients maintain results for 3–4 months. Consistent treatment over time can lengthen the interval as trained muscles relax.',
      },
      {
        q: 'Will I look frozen?',
        a:
          'No. Our approach is deliberately conservative for first visits — you can add more, you can\u2019t take it away. We favour natural movement.',
      },
      {
        q: 'Is Botox safe?',
        a:
          'Neuromodulators have been FDA-approved for aesthetic use since 2002 and have decades of safety data. Complications are rare when treatment is performed by a licensed, physician-supervised injector using genuine product.',
      },
    ],
    servingNearby: [
      'Pasadena', 'South Pasadena', 'Arcadia', 'Alhambra', 'Monterey Park', 'Eagle Rock', 'Silver Lake',
    ],
  },

  'botox-pasadena': {
    slug: 'botox-pasadena',
    primaryKeyword: 'Botox Pasadena',
    title: 'Botox near Pasadena | Akira Signature Care Alhambra',
    metaDescription:
      'Botox® for Pasadena patients at our Alhambra clinic — physician-led injectables with Angela Trias, M.D. Book (626) 737-3183.',
    h1: 'Botox for Pasadena Patients',
    hero: {
      eyebrow: 'PHYSICIAN-LED · SERVING PASADENA',
      subhead:
        'Botox®, Dysport®, Xeomin® and Letybo® at our Alhambra clinic — a short drive from Pasadena.',
      image:
        'https://images.pexels.com/photos/3985338/pexels-photo-3985338.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who this is for',
      body: 'Pasadena patients who want natural, refreshed results \u2014 not a frozen look \u2014 and prefer a physician-led setting a short drive from home. Whether you\u2019re starting preventatively, softening dynamic lines, or refining a long-standing routine, treatment is planned around your anatomy, muscle strength, and how much movement you want to keep.',
    },
    whyPhysicianLed:
      'Our Alhambra clinic sits minutes from Pasadena. Every visit is planned by our physician-led team under the medical direction of Angela Trias, M.D. \u2014 we map your facial dynamics, choose the neuromodulator (Botox®, Dysport®, Xeomin® or Letybo®) that best fits your muscle activity and goals, and dose conservatively. You can always add; you can\u2019t take away.',
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A structured planning session \u2014 goals, medical history, prior injectables, and a facial-mapping review. You receive a written plan with unit counts and cost before we treat.',
      },
      {
        step: 'Treatment',
        body:
          '~10\u201315 minutes with ultra-fine needles. Most patients describe it as a series of quick pinches; topical numbing available on request.',
      },
      {
        step: 'Aftercare',
        body:
          'Resume normal activity right away. Skip heavy workouts, heat, and lying flat for 4 hours. Full result at ~10\u201314 days; we photograph and refine at follow-up.',
      },
    ],
    related: [
      { slug: '/services/botox-alhambra', name: 'Botox in Alhambra' },
      { slug: '/services/dermal-fillers-alhambra', name: 'Dermal Fillers in Alhambra' },
      { slug: '/locations/pasadena', name: 'Our Pasadena Location Page' },
    ],
    faqs: [
      {
        q: 'How far is Akira Signature Care from Pasadena?',
        a:
          'Our Alhambra clinic (506 N Garfield Ave, Ste 210) is about a 10\u201315-minute drive from most of Pasadena via the 110, 210 or Fair Oaks. Street and lot parking are easy.',
      },
      {
        q: 'How much does Botox cost at Akira?',
        a:
          'Pricing is per unit and depends on the areas treated and the neuromodulator selected. Your consultation includes a written plan with exact unit counts and cost before we treat.',
      },
      {
        q: 'How long does Botox last?',
        a:
          'Most patients maintain results for 3\u20134 months. Consistent treatment over time can lengthen the interval as trained muscles relax.',
      },
      {
        q: 'Will I look frozen?',
        a:
          'No. Our approach is deliberately conservative for first visits \u2014 you can add more, you can\u2019t take it away. We favour natural movement.',
      },
      {
        q: 'Is Botox safe?',
        a:
          'Neuromodulators have been FDA-approved for aesthetic use since 2002 and have decades of safety data. Complications are rare when treatment is performed by a licensed, physician-supervised injector using genuine product.',
      },
    ],
    servingNearby: [
      'South Pasadena', 'San Marino', 'Arcadia', 'Alhambra', 'Eagle Rock', 'Silver Lake', 'Monterey Park',
    ],
  },

  'botox-arcadia': {
    slug: 'botox-arcadia',
    primaryKeyword: 'Botox Arcadia',
    title: 'Botox near Arcadia | Akira Signature Care Alhambra',
    metaDescription:
      'Botox® for Arcadia patients at our Alhambra clinic — physician-led injectables with Angela Trias, M.D. Book (626) 737-3183.',
    h1: 'Botox for Arcadia Patients',
    hero: {
      eyebrow: 'PHYSICIAN-LED · SERVING ARCADIA',
      subhead:
        'Botox®, Dysport®, Xeomin® and Letybo® at our Alhambra clinic — a short drive from Arcadia.',
      image:
        'https://images.pexels.com/photos/3985338/pexels-photo-3985338.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who this is for',
      body: 'Arcadia patients who want natural, refreshed results \u2014 not a frozen look \u2014 and prefer a physician-led setting close to home. Whether you\u2019re starting preventatively, softening dynamic lines, or refining a long-standing routine, treatment is planned around your anatomy, muscle strength, and how much movement you want to keep.',
    },
    whyPhysicianLed:
      'Our Alhambra clinic sits minutes from Arcadia. Every visit is planned by our physician-led team under the medical direction of Angela Trias, M.D. \u2014 we map your facial dynamics, choose the neuromodulator (Botox®, Dysport®, Xeomin® or Letybo®) that best fits your muscle activity and goals, and dose conservatively. You can always add; you can\u2019t take away.',
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A structured planning session \u2014 goals, medical history, prior injectables, and a facial-mapping review. You receive a written plan with unit counts and cost before we treat.',
      },
      {
        step: 'Treatment',
        body:
          '~10\u201315 minutes with ultra-fine needles. Most patients describe it as a series of quick pinches; topical numbing available on request.',
      },
      {
        step: 'Aftercare',
        body:
          'Resume normal activity right away. Skip heavy workouts, heat, and lying flat for 4 hours. Full result at ~10\u201314 days; we photograph and refine at follow-up.',
      },
    ],
    related: [
      { slug: '/services/botox-alhambra', name: 'Botox in Alhambra' },
      { slug: '/services/dermal-fillers-alhambra', name: 'Dermal Fillers in Alhambra' },
      { slug: '/locations/arcadia', name: 'Our Arcadia Location Page' },
    ],
    faqs: [
      {
        q: 'How far is Akira Signature Care from Arcadia?',
        a:
          'Our Alhambra clinic (506 N Garfield Ave, Ste 210) is about a 10\u201315-minute drive from most of Arcadia via the 10 or Huntington Drive. Street and lot parking are easy.',
      },
      {
        q: 'How much does Botox cost at Akira?',
        a:
          'Pricing is per unit and depends on the areas treated and the neuromodulator selected. Your consultation includes a written plan with exact unit counts and cost before we treat.',
      },
      {
        q: 'How long does Botox last?',
        a:
          'Most patients maintain results for 3\u20134 months. Consistent treatment over time can lengthen the interval as trained muscles relax.',
      },
      {
        q: 'Will I look frozen?',
        a:
          'No. Our approach is deliberately conservative for first visits \u2014 you can add more, you can\u2019t take it away. We favour natural movement.',
      },
      {
        q: 'Is Botox safe?',
        a:
          'Neuromodulators have been FDA-approved for aesthetic use since 2002 and have decades of safety data. Complications are rare when treatment is performed by a licensed, physician-supervised injector using genuine product.',
      },
    ],
    servingNearby: [
      'Pasadena', 'San Marino', 'Temple City', 'Monrovia', 'Alhambra', 'Rosemead', 'South Pasadena',
    ],
  },

  'dermal-fillers-pasadena': {
    slug: 'dermal-fillers-pasadena',
    primaryKeyword: 'Dermal Fillers Pasadena',
    title: 'Dermal Fillers near Pasadena | Juvéderm & Restylane | Akira',
    metaDescription:
      'Dermal fillers for Pasadena patients at our Alhambra clinic — Juvéderm®, Restylane® & biostimulators with Angela Trias, M.D. (626) 737-3183.',
    h1: 'Dermal Fillers for Pasadena Patients',
    hero: {
      eyebrow: 'PHYSICIAN-LED · SERVING PASADENA',
      subhead:
        'Juvéderm®, Restylane® and biostimulators like Sculptra® — planned by anatomy at our Alhambra clinic, a short drive from Pasadena.',
      image:
        'https://images.pexels.com/photos/3985329/pexels-photo-3985329.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who this is for',
      body: 'Pasadena patients who want to restore lost volume, refine facial proportions, hydrate skin, or soften static lines that Botox alone won\u2019t address. Treatment is planned to your face \u2014 not to trends \u2014 so results look like you, only rested.',
    },
    whyPhysicianLed:
      'Our Alhambra clinic sits minutes from Pasadena. Filler is anatomy, not a menu \u2014 every plan is designed by our physician-led team under the medical direction of Angela Trias, M.D., using product families (Juv\u00e9derm®, Restylane®, and biostimulators such as Sculptra®) matched to your tissue type, thickness, and desired longevity.',
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A structured facial-mapping session where we identify volume loss, asymmetry, and support-point priorities. You receive a written plan before treatment.',
      },
      {
        step: 'Treatment',
        body:
          'Precise, small-syringe placement with cannula or needle depending on the area. Topical numbing plus lidocaine within the product keep the visit comfortable.',
      },
      {
        step: 'Aftercare',
        body:
          'Mild swelling and small bruises are normal for 24\u201372 hours. Avoid strenuous exercise, alcohol, and dental work for the first 24 hours. We photograph and refine at follow-up.',
      },
    ],
    related: [
      { slug: '/services/botox-pasadena', name: 'Botox near Pasadena' },
      { slug: '/services/dermal-fillers-alhambra', name: 'Dermal Fillers in Alhambra' },
      { slug: '/locations/pasadena', name: 'Our Pasadena Location Page' },
    ],
    faqs: [
      {
        q: 'How far is Akira Signature Care from Pasadena?',
        a:
          'Our Alhambra clinic (506 N Garfield Ave, Ste 210) is about a 10\u201315-minute drive from most of Pasadena via the 110, 210 or Fair Oaks. Street and lot parking are easy.',
      },
      {
        q: 'How much do fillers cost at Akira?',
        a:
          'Pricing is per syringe and per product family. Your consultation includes a written treatment plan with clear per-syringe costs before you commit to anything.',
      },
      {
        q: 'How long do fillers last?',
        a:
          'Hyaluronic-acid fillers typically last 9\u201318 months depending on the product and treatment area. Biostimulators like Sculptra® stimulate your own collagen and can last 18\u201324+ months.',
      },
      {
        q: 'Will fillers look obvious?',
        a:
          'Not when planned properly. Overfilled looks come from chasing trends and stacking product; we plan by anatomy and use conservative volumes with follow-up rather than one heavy session.',
      },
      {
        q: 'Are fillers reversible?',
        a:
          'Hyaluronic-acid fillers can be dissolved with hyaluronidase if you don\u2019t like the result. Biostimulators are not reversible, which is one reason we start conservatively.',
      },
    ],
    servingNearby: [
      'South Pasadena', 'San Marino', 'Arcadia', 'Alhambra', 'Eagle Rock', 'Silver Lake', 'Monterey Park',
    ],
  },

  'dermal-fillers-arcadia': {
    slug: 'dermal-fillers-arcadia',
    primaryKeyword: 'Dermal Fillers Arcadia',
    title: 'Dermal Fillers near Arcadia | Juvéderm & Restylane | Akira',
    metaDescription:
      'Dermal fillers for Arcadia patients at our Alhambra clinic — Juvéderm®, Restylane® & biostimulators with Angela Trias, M.D. (626) 737-3183.',
    h1: 'Dermal Fillers for Arcadia Patients',
    hero: {
      eyebrow: 'PHYSICIAN-LED · SERVING ARCADIA',
      subhead:
        'Juvéderm®, Restylane® and biostimulators like Sculptra® — planned by anatomy at our Alhambra clinic, a short drive from Arcadia.',
      image:
        'https://images.pexels.com/photos/3985329/pexels-photo-3985329.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who this is for',
      body: 'Arcadia patients who want to restore lost volume, refine facial proportions, hydrate skin, or soften static lines that Botox alone won\u2019t address. Treatment is planned to your face \u2014 not to trends \u2014 so results look like you, only rested.',
    },
    whyPhysicianLed:
      'Our Alhambra clinic sits minutes from Arcadia. Filler is anatomy, not a menu \u2014 every plan is designed by our physician-led team under the medical direction of Angela Trias, M.D., using product families (Juv\u00e9derm®, Restylane®, and biostimulators such as Sculptra®) matched to your tissue type, thickness, and desired longevity.',
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A structured facial-mapping session where we identify volume loss, asymmetry, and support-point priorities. You receive a written plan before treatment.',
      },
      {
        step: 'Treatment',
        body:
          'Precise, small-syringe placement with cannula or needle depending on the area. Topical numbing plus lidocaine within the product keep the visit comfortable.',
      },
      {
        step: 'Aftercare',
        body:
          'Mild swelling and small bruises are normal for 24\u201372 hours. Avoid strenuous exercise, alcohol, and dental work for the first 24 hours. We photograph and refine at follow-up.',
      },
    ],
    related: [
      { slug: '/services/botox-arcadia', name: 'Botox near Arcadia' },
      { slug: '/services/dermal-fillers-alhambra', name: 'Dermal Fillers in Alhambra' },
      { slug: '/locations/arcadia', name: 'Our Arcadia Location Page' },
    ],
    faqs: [
      {
        q: 'How far is Akira Signature Care from Arcadia?',
        a:
          'Our Alhambra clinic (506 N Garfield Ave, Ste 210) is about a 10\u201315-minute drive from most of Arcadia via the 10 or Huntington Drive. Street and lot parking are easy.',
      },
      {
        q: 'How much do fillers cost at Akira?',
        a:
          'Pricing is per syringe and per product family. Your consultation includes a written treatment plan with clear per-syringe costs before you commit to anything.',
      },
      {
        q: 'How long do fillers last?',
        a:
          'Hyaluronic-acid fillers typically last 9\u201318 months depending on the product and treatment area. Biostimulators like Sculptra® stimulate your own collagen and can last 18\u201324+ months.',
      },
      {
        q: 'Will fillers look obvious?',
        a:
          'Not when planned properly. Overfilled looks come from chasing trends and stacking product; we plan by anatomy and use conservative volumes with follow-up rather than one heavy session.',
      },
      {
        q: 'Are fillers reversible?',
        a:
          'Hyaluronic-acid fillers can be dissolved with hyaluronidase if you don\u2019t like the result. Biostimulators are not reversible, which is one reason we start conservatively.',
      },
    ],
    servingNearby: [
      'Pasadena', 'San Marino', 'Temple City', 'Monrovia', 'Alhambra', 'Rosemead', 'South Pasadena',
    ],
  },

  'dermal-fillers-san-marino': {
    slug: 'dermal-fillers-san-marino',
    primaryKeyword: 'Dermal Fillers San Marino',
    title: 'Dermal Fillers near San Marino | Juvéderm & Restylane | Akira',
    metaDescription:
      'Dermal fillers for San Marino patients at our Alhambra clinic — Juvéderm®, Restylane® & biostimulators with Angela Trias, M.D. (626) 737-3183.',
    h1: 'Dermal Fillers for San Marino Patients',
    hero: {
      eyebrow: 'PHYSICIAN-LED · SERVING SAN MARINO',
      subhead:
        'Juvéderm®, Restylane® and biostimulators like Sculptra® — planned by anatomy at our Alhambra clinic, a short drive from San Marino.',
      image:
        'https://images.pexels.com/photos/3985329/pexels-photo-3985329.jpeg?w=1600&q=80',
    },
    who: {
      title: 'Who this is for',
      body: 'San Marino patients who want to restore lost volume, refine facial proportions, hydrate skin, or soften static lines that Botox alone won\u2019t address. Treatment is planned to your face \u2014 not to trends \u2014 so results look like you, only rested.',
    },
    whyPhysicianLed:
      'Our Alhambra clinic sits minutes from San Marino. Filler is anatomy, not a menu \u2014 every plan is designed by our physician-led team under the medical direction of Angela Trias, M.D., using product families (Juv\u00e9derm®, Restylane®, and biostimulators such as Sculptra®) matched to your tissue type, thickness, and desired longevity.',
    whatToExpect: [
      {
        step: 'Consultation',
        body:
          'A structured facial-mapping session where we identify volume loss, asymmetry, and support-point priorities. You receive a written plan before treatment.',
      },
      {
        step: 'Treatment',
        body:
          'Precise, small-syringe placement with cannula or needle depending on the area. Topical numbing plus lidocaine within the product keep the visit comfortable.',
      },
      {
        step: 'Aftercare',
        body:
          'Mild swelling and small bruises are normal for 24\u201372 hours. Avoid strenuous exercise, alcohol, and dental work for the first 24 hours. We photograph and refine at follow-up.',
      },
    ],
    related: [
      { slug: '/services/botox-san-marino', name: 'Botox near San Marino' },
      { slug: '/services/dermal-fillers-alhambra', name: 'Dermal Fillers in Alhambra' },
      { slug: '/locations/san-marino', name: 'Our San Marino Location Page' },
    ],
    faqs: [
      {
        q: 'How far is Akira Signature Care from San Marino?',
        a:
          'Our Alhambra clinic (506 N Garfield Ave, Ste 210) is a short drive from San Marino \u2014 most patients arrive in 10\u201315 minutes with easy street and lot parking.',
      },
      {
        q: 'How much do fillers cost at Akira?',
        a:
          'Pricing is per syringe and per product family. Your consultation includes a written treatment plan with clear per-syringe costs before you commit to anything.',
      },
      {
        q: 'How long do fillers last?',
        a:
          'Hyaluronic-acid fillers typically last 9\u201318 months depending on the product and treatment area. Biostimulators like Sculptra® stimulate your own collagen and can last 18\u201324+ months.',
      },
      {
        q: 'Will fillers look obvious?',
        a:
          'Not when planned properly. Overfilled looks come from chasing trends and stacking product; we plan by anatomy and use conservative volumes with follow-up rather than one heavy session.',
      },
      {
        q: 'Are fillers reversible?',
        a:
          'Hyaluronic-acid fillers can be dissolved with hyaluronidase if you don\u2019t like the result. Biostimulators are not reversible, which is one reason we start conservatively.',
      },
    ],
    servingNearby: [
      'Pasadena', 'South Pasadena', 'Arcadia', 'Alhambra', 'Monterey Park', 'Eagle Rock', 'Silver Lake',
    ],
  },
};

export const getLocalLander = (slug) => localLanders[slug];
